import { Operator } from '../../FilterFields/types'

function getOperatorThreshold(operator: Operator) {
  const hasUpperThresholdFilter = ['$lt', '$lte'].includes(operator as Operator)

  const hasLowerThresholdFilter = ['$gt', '$gte'].includes(operator as Operator)

  return {
    hasUpperThresholdFilter,
    hasLowerThresholdFilter
  }
}

export default getOperatorThreshold
